<!--
 * @Author: your name
 * @Date: 2020-08-13 15:24:18
 * @LastEditTime: 2020-09-09 16:06:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/contact-details/component/MainText/index.vue
-->
<style scoped lang="sass">
.main_text
  display: flex
  flex-direction: column

  .title
    margin-bottom: 10px
    font-size: 17px
    line-height:20px
    color: var(--menu-primary-text-colour) !important
    font-weight: 500

  .detail
    font-size: 13px
    line-height: 17px
    color: var(--menu-primary-text-colour) !important

</style>

<template lang="pug">
.main_text
  .title {{ title }}
  .detail.o {{ detail }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    title: {
      type: String
    },
    detail: {
      type: String
    }
  }
})
class MainText extends Vue {
}

export default MainText
</script>
